<div class="text-center">
  <img
    class="inline-block"
    ngSrc="assets/images/logo-acciona-mail-light.png"
    width="213"
    height="93"
    alt="{{ 'GENERAL.LOGO' | translate }}"
  />
</div>
<mat-dialog-content>
  @if (_showFullPolicy()) {
    @for (country of _countriesOrder(); track country) {
      @switch (country) {
        @case ('ES') {
          <ac-spanish-privacy-policy />
        }
        @case ('PT') {
          <ac-portuguese-spanish-policy />
        }
      }
      @if (_countriesOrder().length > 1 && $first) {
        <mat-divider class="divider !my-2" />
      }
    }
  } @else {
    @switch (_langSig()) {
      @case ('es') {
        <ng-container [ngTemplateOutlet]="spanishTemplate" />
      }
      @case ('en') {
        <ng-container [ngTemplateOutlet]="englishTemplate" />
      }
      @case ('pt') {
        <ng-container [ngTemplateOutlet]="portugueseTemplate" />
      }
      @default {
        <ng-container [ngTemplateOutlet]="spanishTemplate" />
      }
    }
  }
</mat-dialog-content>
<mat-dialog-actions class="!justify-between">
  <div class="px-3 pt-2">
    <ac-checkbox [formControl]="_acceptDataProtectionPolicyControl">{{ 'PRIVACY.ACCEPT_PRIVACY' | translate }}</ac-checkbox>
  </div>
  <button primary-button (click)="_save()">{{ 'GENERAL.SAVE' | translate }}</button>
</mat-dialog-actions>
<ng-template #spanishTemplate>
  <p class="paragraph-s">
    En cumplimiento de la normativa en materia de protección de datos, le informamos del tratamiento de sus datos con la finalidad de
    gestionar el contrato de suministro de energía eléctrica suscrito. La base jurídica para el tratamiento de los datos es la correcta
    ejecución del contrato. Los datos se conservarán mientras se mantenga la relación y no se solicite sus suspensión y con posterioridad
    durante el plazo de prescripción legal que le resulten de aplicación. No se prevén comunicaciones ni transferencias internacionales de
    datos.
  </p>
  <p class="paragraph-s">Responsables del tratamiento en función del prestador de servicio recogido en su contrato de suministro:</p>
  <ul>
    <li>ACCIONA GREEN ENERGY DEVELOPMENTS, S.L. (con CIF: B-31737422; Avda. Gran Vía de Hortaleza nº1, 28033, Madrid. Tlf: 916576460)</li>
    <li>
      ACCIONA GREEN ENERGY DEVELOPMENTS, S.L. Sucursal em Portugal (CIF: 513143114; Avenida José Gomes Ferreira 13, 2ªEsq, Edificio Atlas
      III, 1495-139 Algés)
    </li>
  </ul>
  <p class="paragraph-s">
    Podrá ejercitar sus derechos de acceso, rectificación, supresión, portabilidad, de limitación y oposición, ante el Responsable del
    tratamiento, dirigiéndose por escrito al Departamento de Protección de datos sito en Avenida Gran Vía de Hortaleza nº3, 28033 Madrid o,
    mediante el formulario disponible en este enlace:
    <a
      href="https://www.acciona-energia.com/es/politica-privacidad/?activeForm=true&_adin=11551547647"
      target="_blank"
      rel="noreferrer noopener"
    >
      FORMULARIO</a
    >, si fuera necesario para poder identificarle, podríamos solicitarle acreditar su identidad. Asimismo, podrá en cualquier momento,
    formular una reclamación ante la Autoridad de Control (Agencia Española de Protección de Datos
    <a href="https://www.aepd.es" target="_blank" rel="noreferrer noopener">www.aepd.es</a>). Tiene disponible información completa en la
    "Política de privacidad" del pie de página. <a (click)="_showFullPolicy.set(true)">Pulse aquí si quiere consultarla ahora.</a>
  </p>
</ng-template>
<ng-template #englishTemplate>
  <p class="paragraph-s">
    In compliance with data protection regulations, we inform you of the processing of your data for the purpose of managing the signed
    electricity supply contract. The legal basis for data processing is the correct execution of the contract. The data will be kept as long
    as the relationship is maintained and its suspension is not requested and subsequently during the applicable legal prescription period.
    No international communications or data transfers are anticipated.
  </p>
  <p class="paragraph-s">Responsible for the treatment depending on the service provider included in your supply contract:</p>
  <ul>
    <li>ACCIONA GREEN ENERGY DEVELOPMENTS, S.L. (con CIF: B-31737422; Avda. Gran Vía de Hortaleza nº1, 28033, Madrid. Tlf: 916576460)</li>
    <li>
      ACCIONA GREEN ENERGY DEVELOPMENTS, S.L. Sucursal em Portugal (CIF: 513143114; Avenida José Gomes Ferreira 13, 2ªEsq, Edificio Atlas
      III, 1495-139 Algés)
    </li>
  </ul>
  <p class="paragraph-s">
    You will be able to exercise your rights of access, rectification, deletion, portability, limitation and opposition, before the
    Responsible for the treatment, by writing to the Data Protection Department located at Avenida Gran Vía de Hortaleza nº3, 28033 Madrid
    or, through the form available at this link:
    <a href="https://www.acciona-energia.com/privacy-policy/?_adin=11551547647#" target="_blank" rel="noreferrer noopener">FORM</a>, if
    necessary to identify you, we may ask you to prove your identity. Likewise, you may at any time, make a claim to the Control Authority
    (Spanish Data Protection Agency <a href="https://www.aepd.es" target="_blank" rel="noreferrer noopener">www.aepd.es</a>). Complete
    information is available in the "Privacy Policy" in the footer.
    <a (click)="_showFullPolicy.set(true)">Click here if you want to view it now.</a>
  </p>
</ng-template>
<ng-template #portugueseTemplate>
  <p class="paragraph-s">
    Em conformidade com os regulamentos de proteção de dados, informamo-lo do tratamento dos seus dados para efeitos de gestão do contrato
    de fornecimento de eletricidade celebrado. A base legal para o tratamento dos dados é a correcta execução do contrato. Os dados serão
    conservados enquanto se mantiver a relação e não for solicitada a sua suspensão e, posteriormente, durante o período de prescrição legal
    que possa ser aplicável. Não está prevista qualquer comunicação ou transferência internacional de dados.
  </p>
  <p class="parágrafo-s">
    Você poderá exercer os seus direitos de acesso, retificação, eliminação, portabilidade, limitação e oposição, perante o Responsável pelo
    tratamento, escrevendo para o Departamento de Proteção de Dados localizado na Avenida Gran Vía de Hortaleza nº3, 28033 Madrid ou,
    através do formulário disponível neste link:
    <a href="https://www.acciona.com.br/politica-privacidad/?activeForm=true&_adin=02021864894" target="_blank" rel="noreferrer noopener"
      >FORMULÁRIO</a
    >, se necessário para identificá-lo, poderemos pedir-lhe que comprove a sua identidade. Da mesma forma, você pode, a qualquer momento,
    fazer uma reclamação à Autoridade de Controle (Agência Espanhola de Proteção de Dados
    <a href="https://www.aepd.es" target="_blank" rel="noreferrer noopener">www.aepd.es</a>). Informações completas estão disponíveis no
    “Política de Privacidade” no rodapé. <a (click)="_showFullPolicy.set(true)">Clique aqui se quiser visualizá-lo agora.</a>
  </p>
</ng-template>
@if (_loadingSig()) {
  <ac-loading-panel />
}
